import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { markRouteReady, markRouteStart } from '../utils/performanceMonitor';

export const RoutePerformanceTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const route = `${location.pathname}${location.search}`;
    markRouteStart(route);
    const timer = window.setTimeout(() => {
      markRouteReady(route, { phase: 'post-route-stabilization' });
    }, 3500);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
};

export default RoutePerformanceTracker;